export const C148_VOLUMES_LABEL = 'C-148 volumes';
export const C148_VOLUMES_SHORT_LABEL = 'C-148';
export const C148_VOLUMES_SOURCE = 'NM OCD C-148 produced-water volume reports';
export const C148_VOLUMES_COMPANION_LINE = 'Official OCD C-148 produced-water volume reports. Monthly summaries per operator. Not current water movement, recycling facility locations, or live water transfers.';
export const C148_VOLUMES_UNIT = 'bbl';
export const C148_VOLUMES_UNIT_BASIS = 'reported_barrels_from_ocd_operator_summary';
export const C148_VOLUMES_TRUST_MISSING = 'NM C-148 produced-water volume reports are not imported yet.';

export const c148VolumesTrustLine = (date?: string | null) => (
  `Imported from NM OCD C-148 produced-water volume reports. Last refreshed ${date || '-'}.`
);

export const C148_VOLUMES_ADMIN_DIAGNOSTIC_LINE =
  'Geometry: none. Map layer: no. Non-spatial monthly operator summaries. Distinct from NM.producedWater recycling-facility locations.';
